module.exports = {
      id: "instagram-square-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-b11c226f9ecc9a258e9645c9abf2e2fd.svg#instagram-square",
      toString: function () {
        return this.url;
      }
    }